export const executeOverviewPublishedDateQuery = "executeOverviewPublishedDateQuery"
export const executeTopProgramsLatestDayQuery = "executeTopProgramsLatestDayQuery"
export const executeTopProgramsSevenDaysQuery = "executeTopProgramsSevenDaysQuery"
export const executeSitesReachSevenDaysQuery = "executeSitesReachSevenDaysQuery"
